import { gql } from '@apollo/client'

export const GET_FARE_RULES = gql`
  query GetFareRules(
    $limit: Int!
    $page: Int!
    $originCityId: String
    $destinationCityId: String
    $originId: String
    $destinationId: String
    $routeServiceId: String
    $dow: [Int!]
  ) {
    fareRules(
      pagination: { size: $limit, page: $page }
      input: {
        originCityID: $originCityId
        destinationCityID: $destinationCityId
        originID: $originId
        destinationID: $destinationId
        routeServiceID: $routeServiceId
        dow: $dow
      }
    ) {
      total
      items {
        id
        name
        description
        enabled
        status
        price
        tripsAffected
        departureAtRanges {
          startAt
          endAt
        }
        activationAtRanges {
          startAt
          endAt
        }
        exceptions {
          dow
        }
        citySegments {
          origin {
            id
            name
          }
          destination {
            id
            name
          }
          allSegments
          segments {
            id
            origin {
              id
              name
              code
            }
            destination {
              id
              name
              code
            }
          }
          allRouteServices
          routeServices {
            id
            code
          }
        }
      }
    }
  }
`

export const GET_FARE_RULE = gql`
  query GetFareRule($fareRuleId: ID!) {
    fareRule(input: { id: $fareRuleId }) {
      id
      companyID
      name
      description
      status
      price
      departureAtRanges {
        startAt
        endAt
      }
      activationAtRanges {
        startAt
        endAt
      }
      exceptions {
        dow
      }
      citySegments {
        origin {
          id
          name
          code
        }
        destination {
          id
          name
          code
        }
        allSegments
        segments {
          id
          origin {
            id
            name
            code
          }
          destination {
            id
            name
            code
          }
        }
        allRouteServices
        routeServices {
          id
          code
        }
      }
    }
  }
`
